import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { initialSurveyHomeQuery } from '@/__generated__/initialSurveyHomeQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { SurveyHomeContainer } from '@/components/survey/home/SurveyHomeContainer';
import { surveyHomeQuery } from '@/graphql/query/survey/init';
import { refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SurveyHomePage() {
  const [queryRef, loadQuery] = useQueryLoader<initialSurveyHomeQuery>(surveyHomeQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId) {
      loadQuery({ refundHistoryId }, { fetchPolicy: 'network-only' });
    }
  }, [refundHistoryId, loadQuery]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_home'} eventProperty={eventAttributes}>
      <SurveyHomeContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SurveyHomePage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default SurveyHomePage;
